import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { css } from '@emotion/css'
import { useLazyGetOneSamlProviderQuery } from '../../../../api/settings.api'

export default function AdapterCard({ adapter, onConfigure, onActivate, onDeactivate }) {
  const [getProvider] = useLazyGetOneSamlProviderQuery()

  const handleConfigure = async () => {
    const result = await getProvider(adapter.id).unwrap()
    onConfigure({
      ...adapter,
      ...result
    })
  }

  return (
    <Box className={styles.card}>
      <Box sx={styles.content}>
        <Box sx={styles.icon}>
          <AdapterIcon />
        </Box>
        <Typography sx={styles.title}>{adapter.domain || 'SAML 2.0 Adapter'}</Typography>
        <Box sx={{ ...styles.status, ...(adapter.active ? styles.active : styles.inactive) }}>
          <Typography>{adapter.active ? 'Active' : 'Inactive'}</Typography>
          {adapter.active && (
            <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M13.5 4.5L6.5 11.4997L3 8'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )}
        </Box>

        <Box sx={styles.actions}>
          <Button sx={styles.button} onClick={handleConfigure}>
            Configure
          </Button>
          {adapter.active ? (
            <Button sx={styles.button} onClick={() => onDeactivate(adapter.id)}>
              Disable
            </Button>
          ) : (
            <Button sx={styles.button} onClick={() => onActivate(adapter.id)}>
              Enable
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  card: css`
    border: 1px solid #e7e7ee;
    border-radius: 14px;
    background-color: #fff;
    padding: 17px 21px;
    width: 322px;
    height: 180px;
    margin-right: 14px;
    margin-bottom: 16px;
  `,
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '10px',
    padding: 0
  },
  icon: {
    marginBottom: 1,
    width: '32px',
    height: '32px',
    color: '#6123FF'
  },
  title: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#1B1B26'
  },
  status: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '4px',
    fontSize: '14px'
  },
  active: {
    color: '#00BC62'
  },
  inactive: {
    color: '#DC3545'
  },
  info: {
    color: '#666',
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: 4
  },
  actions: {
    marginTop: 'auto',
    display: 'flex',
    width: '100%',
    gap: '20px'
  },
  button: {
    fontFamily: 'Plus Jakarta Sans',
    fontSize: '15px',
    color: '#6123FF',
    textTransform: 'none',
    padding: 0,
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#4A1CD9'
    }
  }
}

const AdapterIcon = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16 4C9.373 4 4 9.373 4 16C4 22.627 9.373 28 16 28C22.627 28 28 22.627 28 16C28 9.373 22.627 4 16 4ZM16 26C10.486 26 6 21.514 6 16C6 10.486 10.486 6 16 6C21.514 6 26 10.486 26 16C26 21.514 21.514 26 16 26Z'
      fill='currentColor'
    />
    <path
      d='M16 8C11.582 8 8 11.582 8 16C8 20.418 11.582 24 16 24C20.418 24 24 20.418 24 16C24 11.582 20.418 8 16 8ZM16 22C12.686 22 10 19.314 10 16C10 12.686 12.686 10 16 10C19.314 10 22 12.686 22 16C22 19.314 19.314 22 16 22Z'
      fill='currentColor'
    />
    <path
      d='M16 12C13.791 12 12 13.791 12 16C12 18.209 13.791 20 16 20C18.209 20 20 18.209 20 16C20 13.791 18.209 12 16 12ZM16 18C14.895 18 14 17.105 14 16C14 14.895 14.895 14 16 14C17.105 14 18 14.895 18 16C18 17.105 17.105 18 16 18Z'
      fill='currentColor'
    />
  </svg>
)
